import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { Form } from 'formik';
import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { ThemeContext } from '../../../contexts/Theme';
import {
  fontSize,
  layout,
  media,
  neutral,
  radius,
  space,
} from '../../../theme/tokens';
import { CreateButton } from '../../common/elements/Form';
import { StaffTextFieldInput } from '../../common/elements/Staff';

export const SearchForm = styled(Form)``;

export const SearchStudentsField = (props) => {
  const theme = useContext(ThemeContext);
  const stylesOverride = {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
  };
  return (
    <StaffTextFieldInput
      stylesOverride={stylesOverride}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon style={{ fontSize: fontSize.xl }} />
          </InputAdornment>
        ),
        style: {
          fontSize: fontSize.md,
          color: theme.headerColour,
          background: theme.appBackground,
          height: layout.touchTarget,
          border: `1px solid ${neutral.border}`,
          borderRadius: radius.md,
        },
        ...props.InputProps,
      }}
      {...props}
    />
  );
};

export const Controls = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${space[3]};
  min-width: 0;
`;

export const ControlsWithLink = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-template-areas:
    'invite search'
    '_ link';
  align-items: center;
  column-gap: ${space[3]};
  row-gap: ${space[1]};
  width: 100%;

  ${media.md`
    width: auto;
  `}
`;

export const InviteButton = styled(CreateButton)`
  margin: 0;
`;

export * from './Topics';
